import React, { Component } from "react";

class ApplyBoostProduct extends Component {
  render() {
    return <div>ApplyBoostProduct</div>;
  }
}

export default ApplyBoostProduct;
